// extracted by mini-css-extract-plugin
export default {"root":"FullscreenLayout__root___tsKWF","close":"FullscreenLayout__close___t9zO3"};